import { CompletionTargetAudienceEnum } from '../../../api/ai/enums/completion-target-audience.enum';
import { CompletionLengthEnum } from '../../../api/ai/enums/completion-length.enum';
import { CompletionToneEnum } from '../../../api/ai/enums/completion-tone.enum';
import { AiFormatConfigModel } from '../../Dialogs/models/AI-helper-dialog-config.model';
import { AiQuoteModel } from './ai-quote.model';
import { CompletionPurposeEnum } from '../../../api/ai/enums/completion-purpose.enum';

export class AiSettingFormModel {
    length: CompletionLengthEnum;
    language: string;
    customLanguage: string;
    tone: CompletionToneEnum;
    customTone: string;
    targetAudience: CompletionTargetAudienceEnum;
    customTargetAudience: string;
    purpose: CompletionPurposeEnum;
    customPurpose: string;
    keyMessages: string[] = [''];
    quotes: AiQuoteModel[] = [];
    formatConfig: AiFormatConfigModel = new AiFormatConfigModel();

    constructor() {
        // default AI settings
        this.language = 'en-US';
        this.length = CompletionLengthEnum.AVERAGE;
        this.tone = CompletionToneEnum.PROFESSIONAL;
        this.targetAudience = CompletionTargetAudienceEnum.GENERAL_PUBLIC;
        this.purpose = CompletionPurposeEnum.STORY_PITCH;
    }
}
